<template>
<div class="GateWayFail">
         <div>
        <q-card flat bordered class="" style="border: 1px solid #e9e9e9; border-radius: 1rem; height: 100%; ">
            <q-card-section>
                <!-- <div class="text-bold" style="font-size: 16px; padding-bottom: 10px">{{ $t("common.fail") }}</div> -->
                        <!-- <big>{{$t("common.success")}}</big> -->
                <!-- <q-separator/> -->
                <div class="">
                    <!-- <div class="col-1 q-pl-xs">
						<img src="@/assets/user.png" width="50px" height="50px">
                    </div> -->
                    <!-- <div class="col-xs-12 col-sm-2 col-md-4 text-center q-py-md" >
                       <img  src="@/assets/fail.png" width="80px" height="80px" style="margin-left: auto; margin-right: auto; display: block">
                    </div> -->
                    <div style="display: flex; " class="q-pa-md">
                        
                        <!-- <big>{{$t("common.fail")}}</big> -->
                        <!-- <br/> -->
                         <!-- <a class="text-caption" style="color:red;">{{StoreStateAD.FailReason}}</a><br> -->
                       <!-- <img  src="@/assets/fail.png" width="40px" height="40px" style="display: block; "> -->
                       <img  src="@/assets/fail.png" width="80px" height="80px" style="display: block; margin-left: auto; margin-right: auto">
                        <!-- <div class="q-pl-md q-py-sm text-bold" style="color:#ff6666; font-size: 16px;">{{StoreStateAD.FailReasonTitle}}</div> -->
                        <!--<a class="text-caption" style="color:red;">{{StoreStateAD.FailReasonBody}}</a><br> -->
                    </div>
                    <div class="q-px-sm text-bold text-center" style="font-size: 20px; color: #FF6666">{{$t("common.fail")}}</div>
                    <div class="q-px-sm q-mb-md text-bold text-center" style="font-size: 14px;">{{StoreStateAD.FailReasonTitle}}</div>
                    
                    <q-separator style=""/>

                    <div class="q-pt-md" style="display: flex; justify-content: center">
                        <div class="row q-pa-sm" style="font-size: 14px; max-width: 500px">
                            <div class="col-xs-12 col-md-6 text-bold">
                                {{$t("AccountHolder.investor")}}
                            </div>
                            <div class="col-xs-12 col-md-6 q-mb-md">
                                <div> {{StoreStateAOD.PersonalInformation.FullName}}</div>
                            </div>
                        
                            <div class="col-xs-12 col-md-6 text-bold">
                                {{$t("AccountHolder.epfno")}}
                            </div>
                            <div class="col-xs-12 col-md-6 q-mb-md">
                                <div> {{StoreStateAOD.PersonalInformation.EPFNumber}}</div>
                            </div>
                        
                            <div class="col-xs-12 col-md-6 text-bold">
                                {{$t("AccountHolder.epftype")}}
                            </div>
                            <div class="col-xs-12 col-md-6 q-mb-md">
                                <div> {{StoreStateAOD.PersonalInformation.EPFAccount}}</div>
                            </div>
                        </div>
                    </div>

                    <!-- <div class="q-pa-md" style="display: flex; justify-content: center"> -->
                        <!-- <div style="border-radius: 0.5rem; background: #f5f5f5; padding: 20px"> -->

                        <!-- <q-card-section>
                        <div class="text-bold" style="font-size: 16px;">{{ $t("TacPage.accdetails") }}</div>
                        </q-card-section>
                        <q-separator style="margin: 0 0.75rem; width: auto;"/>
                        <q-card-section> -->
                        <!-- <Address></Address> -->
                    <!-- </div> -->

                </div>
            </q-card-section>
        </q-card>
    </div>
</div>
    
</template>
<script>
import { mapActions } from 'vuex';
import store from '../store'
import Address from '@/components/Address.vue'

export default {
    name : 'GateWayFail',
    components : {
        Address
    },
    data() {
        return {
            StoreStateAD : store.state.AD,
            StoreStateT : store.state.Transactions,
			StoreStateAOD : store.state.AOD,
        }
    },
    mounted(){
       
    },
    computed: {

    },
    methods: {
        

    }
}
</script>